

export const environment = {
  production: false,


  // API_URL: "https://devapi-mhh.approd.ca/"
  // API_URL: "https://backendapi.homehealthcheck.ca/",
  API_URL: "https://api1.approd.ca/",




};



